// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__3SKgd","contentContainer":"Footer_contentContainer__97g0t","cards":"Footer_cards__yETGv","divider":"Footer_divider__tItJJ","legals":"Footer_legals__irKJ2"};